'use client';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
import styled from '@emotion/styled';
import { typography, size, colors, breakpoints } from "@argo/principles";
import Links from './components/links';
import Social from './components/social';
import Copyright from './components/copyright';
import { fallbackSocialLinks, fallbackCopyrightLinks } from './constants';
import useAnalyticsClick from '../../../analytics/react/useAnalyticsClick';
import navigationFallback from '../headermykbb/navigationFallback';
const Footer = styled('div')`
    font-family: ${typography.family.opensans};
    font-size: ${size.xxxl};
    margin: ${props => props.isFullWidth ? 'auto' : '0 auto'};
    left: 0;
    top: 0;
    width: 100%;
    background-color: ${colors.primary.marineBlue};
    width: 100%;

    ${props => props.withToolbar ? `+ div
            {
                background-color: ${colors.primary.marineBlue};
            }
        ` : null}
`;
const FooterWrapper = styled('div')`
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    margin: 0 auto;
    padding: ${size.xl}px 0 ${size.xxxl}px 0 ;
    width: 100%;
    max-width: ${props => props.maxWidth || size.contentMaxWidth || 1280}px;
`;
const FooterSocialCopy = styled('div')`
    display: flex;
    margin: 0 ${size.sm}px ${size.sm}px;
    flex-direction: column;
    justify-content: center;

    @media (min-width: ${breakpoints.md}px) {
        flex-direction: row;
        flex-wrap: wrap;
        align-items: flex-start;
    }

    @media (min-width: ${breakpoints.lg}px) {
        margin: 0 ${size.md}px 0 ${size.md}px;
    }
`;
const GlobalFooterBase = ({
  isFullWidth,
  withToolbar,
  navigation,
  socialLinks,
  copyrightLinks,
  enableOneTrust = false,
  pageId,
  handleFooterClick = () => {}
}) => {
  let footerLinks = navigation && navigation.footerLinks && navigation.footerLinks.length > 0 ? navigation.footerLinks : null;
  if (!footerLinks) {
    if (typeof window !== 'undefined') {
      console.warn('Global-nav fallback footerlinks are used instead of latest navigation in s3 bucket file.');
      console.warn('Enable Onetrust:::', enableOneTrust);
    }
    footerLinks = navigationFallback.footerLinks;
  }
  const onAnalyticsClick = useAnalyticsClick();
  const triggerAnalytics = ({
    googleTag,
    pixallTag
  }) => {
    handleFooterClick({
      googleTag,
      pixallTag
    });
    return onAnalyticsClick(() => {
      const analyticsData = {
        event: 'analytics_event',
        eventElement: 'global-nav-footer',
        eventAction: 'click',
        eventResult: googleTag,
        eventNonInteractive: false,
        eventData: {}
      };
      const pixallData = {
        event: 'pixall',
        eventSource: 'application',
        eventType: 'click',
        feature: 'global-nav-footer',
        label: pixallTag,
        dealerCode: 'kbbcox',
        fullURL: window.location.href,
        program: 'DealerDotCom',
        wspCode: 'KBB',
        pageId: pageId
      };
      let result = {
        type: 'click'
      };
      if (googleTag) {
        result.googleAnalytics = {
          props: analyticsData
        };
      }
      if (pixallTag) {
        result.pixall = {
          props: pixallData
        };
      }
      return result;
    });
  };
  return React.createElement(Footer, {
    id: "globalFooter",
    isFullWidth: isFullWidth,
    withToolbar: withToolbar
  }, React.createElement(FooterWrapper, null, React.createElement(Links, {
    links: footerLinks,
    triggerAnalytics: triggerAnalytics
  }), React.createElement(FooterSocialCopy, null, React.createElement(Social, {
    links: socialLinks,
    enableOneTrust: enableOneTrust
  }), React.createElement(Copyright, {
    links: copyrightLinks,
    triggerAnalytics: triggerAnalytics,
    enableOneTrust: enableOneTrust
  }))));
};
const GlobalFooter = ({
  socialLinks = fallbackSocialLinks,
  copyrightLinks = fallbackCopyrightLinks,
  ...props
}) => {
  return React.createElement(GlobalFooterBase, _extends({}, props, {
    socialLinks: socialLinks,
    copyrightLinks: copyrightLinks
  }));
};
GlobalFooter.displayName = 'GlobalFooter';
export default GlobalFooter;